import { yupResolver } from '@hookform/resolvers/yup';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { FormProvider, useForm } from 'react-hook-form';

import { walletModalBunja } from '../shared/core/state';
import { ConvertForm } from './phase/1-form';
import { Preview } from './phase/2-preview';
import { ConversionCompleteForm } from './phase/3-complete';
import { ConvertFormSchema, convertFormValidator } from './shared/validation';
import { convertModalBunja } from './state';

export const Content = () => {
  const {
    options: { defaultValues },
  } = useBunja(walletModalBunja);
  const { Steps, steps, selectedCurrencyAtom } = useBunja(convertModalBunja);
  const current = useAtomValue(steps.currentStepAtom);
  const selectedCurrency = useAtomValue(selectedCurrencyAtom);

  const methods = useForm<ConvertFormSchema>({
    resolver: yupResolver(convertFormValidator), // 여긴 context 를 넘겨서 validation 하기위해 form validation 제거
    defaultValues: {
      fromCurrency: selectedCurrency!,
      toCurrency: defaultValues.toCurrency || undefined,
    },
  });

  return (
    <FormProvider {...methods}>
      <Steps model={current}>
        <Steps.Step step='form'>{() => <ConvertForm />}</Steps.Step>
        <Steps.Step step='preview'>{() => <Preview />}</Steps.Step>
        <Steps.Step step='complete'>{() => <ConversionCompleteForm />}</Steps.Step>
      </Steps>
    </FormProvider>
  );
};
